if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('[data-product-modal-prev]');
        this.nextButton = this.querySelector('[data-product-modal-next]');
        this.currentMediaIndex = 0;
        this.mediaItems = [];

        if (this.prevButton) {
          this.prevButton.addEventListener('pointerup', (event) => event.stopPropagation());
          this.prevButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.showRelativeMedia(-1);
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('pointerup', (event) => event.stopPropagation());
          this.nextButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.showRelativeMedia(1);
          });
        }

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showRelativeMedia(-1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.showRelativeMedia(1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        const mediaId = opener && opener.getAttribute('data-media-id');
        this.showActiveMedia(mediaId);
      }

      showRelativeMedia(step) {
        if (!this.mediaItems.length || this.mediaItems.length < 2) return;
        let nextIndex = this.currentMediaIndex + step;

        if (nextIndex < 0) nextIndex = this.mediaItems.length - 1;
        if (nextIndex >= this.mediaItems.length) nextIndex = 0;

        const nextMedia = this.mediaItems[nextIndex];
        if (!nextMedia) return;
        this.showActiveMedia(nextMedia.dataset.mediaId);
      }

      showActiveMedia(preferredMediaId) {
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        if (!this.mediaItems.length) return;
        window.pauseAllMedia();

        const fallbackMediaId = this.openedBy && this.openedBy.getAttribute('data-media-id');
        const activeMediaId = preferredMediaId || fallbackMediaId;

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${activeMediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`) || this.mediaItems[0];
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'nearest', inline: 'center' });

        this.currentMediaIndex = this.mediaItems.indexOf(activeMedia);

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = 0;

        this.updateNavState();

        const deferredMedia =
          activeMedia.matches('deferred-media, product-model') ?
            activeMedia
          : activeMedia.querySelector('deferred-media, product-model');

        if (
          deferredMedia &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          deferredMedia.loadContent();
      }

      updateNavState() {
        const hasMultiple = this.mediaItems.length > 1;
        [this.prevButton, this.nextButton].forEach((button) => {
          if (!button) return;
          button.toggleAttribute('hidden', !hasMultiple);
          button.disabled = !hasMultiple;
        });
      }
    }
  );
}
